import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { pdfjs } from 'react-pdf'
import { getEnv } from 'shared/lib/getEnv'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const { ENABLED_SENTRY, SENTRY_USER, SENTRY_PASS, SENTRY_APP, NODE_ENV } = getEnv

const allowSentry = ENABLED_SENTRY === 't'

if (allowSentry) {
  Sentry.init({
    dsn: `https://${SENTRY_USER}@${SENTRY_PASS}.ingest.sentry.io/${SENTRY_APP}`,
    integrations: [new Integrations.BrowserTracing()],
    environment: NODE_ENV,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.001,
    beforeSend: (event) => {
      return event
    },
  })
}

ReactDOM.render(<App />, document.getElementById('root'))
